export default __webpack_public_path__ + "static/media/Contacts.9fd9fc81.csv";